import { light } from '@fortawesome/fontawesome-svg-core/import.macro';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useState } from 'react';
import { Modal, ModalBody, ModalFooter } from 'react-bootstrap';
import Button from '../../../../components/Button';
import Link from '../../../../components/Link';
import ModalHeader from '../../../../components/ModalHeader';
import Radio, { RadioGroup } from '../../../../components/Radio';
import CustomSelect from '../../../../components/Select/Select';
import { getAllStates } from '../../../../services/states';
import { getEffectiveDate } from '../../../../utils/utils';
import StateTaxForm from './StateTaxForm';

export type StateTaxModalProps = {
  show: boolean;
  handleClose: () => void;
  data: any;
  collectData: (data: any) => void;
};

const StateTax = ({
  show,
  handleClose,
  data,
  collectData,
}: StateTaxModalProps) => {
  const [updatedStateTaxData, setUpdatedStateTaxData] = useState(data);

  const handleUpdateStateTaxData = (data: any) => {
    setUpdatedStateTaxData(data);
  };

  const options: any = getAllStates();

  const handleSelectState = (e: any) => {
    const selected = options.find((el: any) => el.value === e);

    setUpdatedStateTaxData({
      ...updatedStateTaxData,
      state: selected,
      taxOption: undefined,
      martialStatus: { value: undefined, label: undefined },
      numberOfAllowances: undefined,
      additionalAmount: undefined,
    });
  };

  const handleChange = (e: string | number) => {
    setUpdatedStateTaxData({
      ...updatedStateTaxData,
      taxOption: e,
    });
  };

  const handleChangeData = (data: any) => {
    collectData(data);
  };

  return (
    <Modal
      show={show}
      onHide={handleClose}
      size="lg"
      className="custom-state-tax-modal"
    >
      <ModalHeader closeButton>
        <h4>State of Legal Residence</h4>
      </ModalHeader>
      <ModalBody>
        <div>
          <span className="text-caption fw-light text-gray-600 lh-xs">
            Which state will be your legal residence for tax purposes when you
            receive your payments?
          </span>
        </div>
        <div className="mt-7 px-11 py-10">
          <div>
            <CustomSelect
              options={options}
              onChange={handleSelectState}
              value={updatedStateTaxData.state.value || ''}
            />
          </div>
          {!updatedStateTaxData.state.value && (
            <div className="mt-10 d-flex justify-content-between">
              <span className="text-caption lh-xs">
                {`Effective Date: ${getEffectiveDate(new Date().getDate())}`}
              </span>
              <span className="lh-xs">
                <Link
                  className={'py-0'}
                  href={
                    'https://www.usa.gov/state-taxes'
                  }
                  target="_blank"
                >
                  <span className="text-caption text-indigo fw-light">
                    <FontAwesomeIcon icon={light('file')} className="pe-3" />
                    Things to consider
                  </span>
                </Link>
              </span>
            </div>
          )}
        </div>
        {updatedStateTaxData.state.value && (
          <>
            <div className="pt-13">
              <RadioGroup
                name={'state-tax'}
                value={updatedStateTaxData.taxOption}
                onChange={handleChange}
              >
                <div className='border-bottom light-gray pb-4'>
                  <div className="d-flex justify-content-between">
                    <div className="radio-btn-col px-3">
                      <Radio
                        value={'1'}
                        id={'1'}
                        label={
                          'Do not withhold taxes - I will be responsible for any taxes owed.'
                        }
                      />
                    </div>
                  </div>
                </div>
                <div className={` rounded-2 px-3 ${updatedStateTaxData.taxOption === '2' &&
                updatedStateTaxData.state.value !== 'TX'?'gray-nested-background':''}`}>
                  {updatedStateTaxData.state.value !== 'TX' && (
                    <div
                      className={`${
                        updatedStateTaxData.taxOption === '2'
                          ? 'selected-radio'
                          : ''
                      }`}
                    >
                      <div className={`d-flex justify-content-between radio-title pt-5 ${updatedStateTaxData.taxOption === '2' &&
                      updatedStateTaxData.state.value !== 'TX'?'border-bottom light-gray':''}  `}>
                        <div className='radio-btn-col'>
                          <Radio
                            value={'2'}
                            id={'2'}
                            label={
                              updatedStateTaxData.state.value !== 'NJ'
                                ? 'Calculate taxes based upon my marital status and allowances'
                                : 'Withhold a fixed dollar amount'
                            }
                          />
                        </div>
                        <div className='radio-btn-col radio-btn-icon ms-7 ms-lg-0 d-flex align-items-center'>
                          <FontAwesomeIcon
                            icon={light('chevron-down')}
                            className='arrow-svg'
                          />
                        </div>
                      </div>
                    </div>
                  )}
                  {updatedStateTaxData.taxOption === '2' &&
                    updatedStateTaxData.state.value !== 'TX' && (
                      <section>
                        <div className='mt-7 pb-10 px-3'>
                          <StateTaxForm
                            data={updatedStateTaxData}
                            collectData={handleUpdateStateTaxData}
                          />
                        </div>
                      </section>
                    )}
                </div>
              </RadioGroup>


            </div>



            <div className='mt-13 d-flex justify-content-between'>
              <span className='text-caption lh-xs'>
                Effective Date: Mar 17, 2023
              </span>
              <span className="lh-xs">
                <Link
                  className={'py-0'}
                  href={
                    'https://fiscal.treasury.gov/state-and-local-withholding/'
                  }
                  target="_blank"
                >
                  <span className="text-caption text-indigo fw-light">
                    <FontAwesomeIcon icon={light('file')} className="pe-3" />
                    Things to consider
                  </span>
                </Link>
              </span>
            </div>
          </>
        )}
      </ModalBody>
      <ModalFooter>
        <Button
          variant="primary-outline"
          onClick={() => {
            setUpdatedStateTaxData(data);
            handleClose();
          }}
          className="mt-7 mt-lg-0"
        >
          Cancel
        </Button>
        <Button
          variant="primary"
          onClick={() => {
            handleChangeData(updatedStateTaxData);
            handleClose();
          }}
          className="mt-7 mt-lg-0"
        >
          Change
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default StateTax;
